// gtm.ts
// import TagManager from "react-gtm-module";

export interface EcommerceItem {
  item_id: string;
  item_name: string;
  item_brand: string;
  item_category: string;
  price: number;
  quantity: number;
}

export interface EcommerceEvent {
  event: string;
  ecommerce: {
    value: number;
    currency: string;
    items: EcommerceItem[];
  };
}

const tagManagerArgs = {
  gtmId: "GTM-N24888V" // ID GTM
};

export const initializeGTM = () => {
  // TagManager.initialize(tagManagerArgs);
};

export const pushAddToCartEventGTM = (value: number, currency: string, items: EcommerceItem[]) => {
  const event: EcommerceEvent = {
    event: "add_to_cart",
    ecommerce: {
      value,
      currency,
      items
    }
  };

  // (window as any).dataLayer = (window as any).dataLayer || [];
  // (window as any).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  // (window as any).dataLayer.push(event);

  const message = {
    type: "addToCardGTM",
    data: event
  };
  window.parent.postMessage(message, "*");
};

export const pushRemoveFromCartEventGTM = (value: number, currency: string, items: EcommerceItem[]) => {
  const event: EcommerceEvent = {
    event: "remove_from_cart",
    ecommerce: {
      value,
      currency,
      items
    }
  };

  const message = {
    type: "removeFromCardGTM",
    data: event
  };
  window.parent.postMessage(message, "*");
};

export const pushViewCartEventGTM = (value: number, currency: string, items: EcommerceItem[]) => {
  const event: EcommerceEvent = {
    event: "view_cart",
    ecommerce: {
      value,
      currency,
      items
    }
  };

  const message = {
    type: "viewCardGTM",
    data: event
  };
  window.parent.postMessage(message, "*");
};

export const pushBeginCheckoutEventGTM = (value: number, currency: string, items: EcommerceItem[], coupon: string) => {
  const event = {
    event: "begin_checkout",
    ecommerce: {
      value,
      currency,
      coupon,
      items
    }
  };

  const message = {
    type: "beginCheckoutGTM",
    data: event
  };
  window.parent.postMessage(message, "*");
};

export const pushPurchaseEventGTM = (
  value: number,
  currency: string,
  items: EcommerceItem[],
  coupon: string,
  transaction_id: string
) => {
  const event = {
    event: "purchase",
    ecommerce: {
      value,
      currency,
      coupon,
      transaction_id,
      shipping: 0,
      tax: 8,
      items
    }
  };

  const message = {
    type: "purchaseGTM",
    data: event
  };
  window.parent.postMessage(message, "*");
};

export const pushPrePurchaseEventGTM = (
  value: number,
  currency: string,
  items: EcommerceItem[],
  coupon: string,
  transaction_id: string
) => {
  const event = {
    event: "prepurchase",
    ecommerce: {
      value,
      currency,
      coupon,
      transaction_id,
      shipping: 0,
      tax: 8,
      items
    }
  };

  console.log("prepurchase: ", event);
  const message = {
    type: "prePurchaseGTM",
    data: event
  };
  window.parent.postMessage(message, "*");
};
